import { api, sp } from "./_base";


export const getAlloyDarkstatByConfig = async (configId, schemaName = null) => {
  try {
    const response = await api.get(`/alloy-darkstat/`, { params: { alloy_config: configId, ...sp(schemaName) } });
    return response.data;
  } catch (error) {
    console.error("Error fetching Darkstat jobs:", error);
    throw error;
  }
};

export const getAlloyDarkstatById = async (id, schemaName = null) => {
  try {
    const response = await api.get(`/alloy-darkstat/${id}/`, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error fetching Darkstat job:", error);
    throw error;
  }
};

export const createAlloyDarkstat = async (data, schemaName = null) => {
  try {
    const response = await api.post("/alloy-darkstat/", data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error creating Darkstat job:", error);
    throw error;
  }
};

export const updateAlloyDarkstat = async (id, data, schemaName = null) => {
  try {
    const response = await api.put(`/alloy-darkstat/${id}/`, data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error updating Darkstat job:", error);
    throw error;
  }
};

export const deleteAlloyDarkstat = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/alloy-darkstat/${id}/`, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error deleting Darkstat job:", error);
    throw error;
  }
};
